<template>
  <component
    :is="componentType"
    :type="!link ? type : false"
    :to="redirectionLink"
    class="button button-outline"
    :class="{ 'disabled': disabled }"
    data-testid="subscribeSubmit"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot>
      Button
    </slot>
  </component>
</template>
<script>
import BaseButton from './BaseButton'

export default {
  name: 'ButtonOutline',
  mixins: [ BaseButton ]
}
</script>
